import { AfterLoginHeader } from "../../Header/AfterLoginHeader";
import { useEffect, useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import Drawer from "react-modern-drawer";
import { useSelector } from "react-redux";
import SideBar from "../SideBar";
import classes from "./SideBarSkeleton.module.css";
import { isMobileViewHook } from "../../../customHooks/isMobileViewHook"; // Corrected path assuming it's in src/customHooks
import { cn } from "@/helper/HelperFunction";

const SideBarSkeleton = ({
  children,
  headerHeading,
  floating = false,
  layout = "vertical",
}) => {
  const { isSidebarCollapsed } = useSelector((state) => state.authReducer);
  const [isMobile, setIsMobile] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false); // Renamed for clarity

  const toggleDrawer = () => {
    setIsDrawerOpen((prevState) => !prevState);
  };

  useEffect(() => {
    isMobileViewHook(setIsMobile); // Simplified setIsMobile usage
    // Add resize listener if needed, or rely on initial check + CSS media queries
    const handleResize = () => isMobileViewHook(setIsMobile);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className={cn(
        classes.wrapper,
        !isMobile && classes[layout],
        isSidebarCollapsed && classes.sidebarCollapsed
      )}
    >
      <div className={cn(classes.headerContainer)}>
        <AfterLoginHeader
          showLogo={false}
          drawerBtn={
            isMobile && (
              <GiHamburgerMenu
                className={classes.GiHamburgerMenuMobile}
                onClick={toggleDrawer}
              />
            )
          }
          header={headerHeading}
        />
      </div>
      {isMobile ? (
        <Drawer
          open={isDrawerOpen}
          onClose={toggleDrawer}
          direction="left"
          className={classes.drawerContainer} // Ensure this class applies needed width/bg
        >
          <SideBar isMobile={true} showLogo={true} floating={false} />{" "}
        </Drawer>
      ) : (
        <div className={cn(classes.sidebarContainer)}>
          <div
            className={cn(
              classes.sidebarDiv,
              isSidebarCollapsed && classes.iscollapsed
            )}
          >
            <SideBar
              isMobile={false}
              showLogo={true}
              floating={false}
              layout={layout}
            />
          </div>
        </div>
      )}
      <div
        className={cn(classes.pageMain, floating && classes.pageMainFloating)}
      >
        {children}
      </div>
    </div>
  );
};

export default SideBarSkeleton;
